export const phishingHero = {
  severity: "High Severity",
  title: "Technique: T1566 - Phishing",
  description:
    "Adversaries may send phishing messages to gain access to victim systems. All forms of phishing are targeted at individuals and exploit social engineering to deliver a payload or link.",
  score: 82,
};

export const aiSummary = {
  text: "Analysis confirms this is a Spear-Phishing attempt targeting OT Engineers. The payload was an obfuscated .exe masquerading as a 'Firmware Update'.",
};

export const phishingEvents = [
  { time: "10:15 AM", text: "Inbound Email: “Urgent: System Update” from it-support@malicious.com", tone: "info" },
  { time: "10:15 AM", text: "Link Clicked by User: J.Doe (Lead Engineer)", tone: "warning" },
  { time: "10:15 AM", text: "Redirected to: http://secure-update-portal.net/login.php", tone: "alert" },
  { time: "10:15 AM", text: "Credential Harvesting Attempt detected on landing page", tone: "warning" },
  { time: "10:15 AM", text: "Background download initiated: firmware_v4.exe", tone: "info" },
  { time: "10:15 AM", text: "Executable blocked by Secure Boot (Policy: No-Exec)", tone: "success" },
  { time: "10:15 AM", text: "Automated account lockout for J.Doe (initiated by AI)", tone: "success" },
];

export const affectedAssets = [
  { name: "ENG-STATION-04", desc: "Windows 11 / Workstation", status: "Quarantined", risk: "High", riskTone: "riskHigh" },
  { name: "HMI-ROOM-X", desc: "Siemens Touch Panel", status: "Monitored", risk: "Medium", riskTone: "riskMedium" },
  { name: "IoT-SENSOR-247", desc: "Temperature Sensor", status: "Safe", risk: "Low", riskTone: "riskLow" },
  { name: "HMI-ROOM-X", desc: "Siemens Touch Panel", status: "Monitored", risk: "Medium", riskTone: "riskMedium" },
  { name: "ENG-STATION-04", desc: "Windows 11 / Workstation", status: "Quarantined", risk: "High", riskTone: "riskHigh" },
  { name: "IoT-SENSOR-247", desc: "Temperature Sensor", status: "Safe", risk: "Low", riskTone: "riskLow" },
];

export const deepDiveLogs = [
  { asset: "ENG-STATION-04", src: "192.168.10.5", dest: "104.22.1.88", proto: "HTTPS", bytes: "420 KB", flag: "DGA Detected" },
  { asset: "ENG-STATION-04", src: "192.168.10.5", dest: "Local DNS", proto: "DNS", bytes: "12 KB", flag: "Beaconing" },
  { asset: "HMI-ROOM-X", src: "192.168.10.12", dest: "Internal-01", proto: "SMB", bytes: "0 KB", flag: "Access Denied" },
  { asset: "PLC-GATEWAY", src: "172.16.5.1", dest: "192.168.10.5", proto: "TCP", bytes: "5 MB", flag: "Large File Transfer" },
];
